import NonMatchingParamKey from '@type/NonMatchingParamKey';

const isNonMatchingParamKey = (paramKey: string | NonMatchingParamKey): paramKey is NonMatchingParamKey => {
    if (
        typeof paramKey === 'object' &&
        paramKey !== null &&
        'urlKey' in paramKey &&
        'salesforceKey' in paramKey &&
        paramKey.urlKey !== paramKey.salesforceKey
    ) {
        return true;
    } else if (typeof paramKey === 'string' || paramKey.urlKey === paramKey.salesforceKey) {
        return false;
    }
};

export default isNonMatchingParamKey;
